import type { IconData } from '@stacksjs/iconify-core'

export const padlock: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 12v6h10v-6zm10-2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V5a5 5 0 1 1 10 0zm-2 0V5a3 3 0 1 0-6 0v5zm-3 7a2 2 0 1 1 0-4a2 2 0 0 1 0 4\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default padlock
